/**
 * Created by lu on 2017/7/22.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view: {
        'class': ['input-wrap', nb.bind('inputBorder'), nb.bind('status')],
        $html: [{
            'class': ['label-text', nb.bind('isMust')],
            $text: nb.bind('label')
        }, {
            'class': 'input-box',
            $html: [{
                $type: require('./Input'),
                $model: ''
            }]
        }, {
            'class': 'msg-block',
            $html: {
                tag: 'span',
                $text: nb.bind('errorMsg')
            }
        }]
    },
    method: {
        init: function () {

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/form/InputWithLabel.js
// module id = 45
// module chunks = 0 2 4 6 9 10 13 18 21 32 35